import React, { Component } from "react";
import TextBox from "../widget/TextBox";
import Datepicker from "../widget/DatePicker/DatePicker";
import "./FilterSearchtext.css";

class FilterSearchText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warningText: "",
    };
    // textstate = false
  }

  handleInputChange = (obj1, obj2) => {
    // Validation condition
    console.log(obj1, obj2)
  if (obj1 === "claimNumber" && obj2.length > 0 && obj2.length < 4) {
    this.setState({ warningText: "Enter at least 4 characters" });
  } else if(obj1 === "renderingNPI" && obj2.length > 0 && obj2.length < 4){
    this.setState({ warningText: "Enter at least 4 characters" });
  }else if(obj1 === "billingNPI" && obj2.length > 0 && obj2.length < 4){
    this.setState({ warningText: "Enter at least 4 characters" });
  }
  else {
    this.setState({ warningText: "" });
  }
    this.props.filterTextchange(obj1, obj2);
  };

  // Filter input Text
  selectFilter = (ftype, id) => {
    switch (ftype) {
      case "text":
        return(<> <TextBox id={id} change={this.handleInputChange} setField={this.props.setField}/>
          {this.state.warningText && (
            <p style={{ color: "lightcoral", fontSize: "12px", fontWeight: "normal" }}>
              {this.state.warningText}
            </p>
          )}
        </>)
      case "date":
        return <Datepicker id={id} change={this.handleInputChange} />;
      default:
        return <TextBox id={id} change={this.handleInputChange} />;
    }
  };

  render() {
    // console.log(this.props.filterstate, this.props.headerstate);
    return <div>{this.selectFilter(this.props.ftype, this.props.id)}</div>;
  }
}

export default FilterSearchText;
